var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGettingStartedGuildBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 91,
    viewBox: "0 0 95 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1058 91C73.1217 91 94.2118 70.6289 94.2118 45.5C94.2118 20.371 73.1217 0 47.1058 0C21.09 0 0 20.371 0 45.5C0 70.6289 21.09 91 47.1058 91Z",
    fill: "#DEF6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5414 30.1665C53.0663 26.7877 56.5553 24.4258 60.615 24.4258C64.586 24.4258 68.0101 26.6852 69.5853 29.9455C69.8894 29.9154 70.1975 29.9 70.5098 29.9C75.5141 29.9 79.571 33.8189 79.571 38.6524C79.571 41.7794 77.8731 44.5242 75.3189 46.0718M51.5414 30.1665C49.8304 29.5731 47.9857 29.2495 46.0629 29.2495C39.6689 29.2495 34.1386 32.8247 31.4996 38.0185C30.8426 37.9326 30.1718 37.888 29.4901 37.888C21.2892 37.888 14.6408 44.3098 14.6408 52.2311C14.6408 60.1525 21.2892 66.5743 29.4901 66.5743H64.9947C72.2429 66.5743 78.1186 60.8989 78.1186 53.8978C78.1186 50.944 77.0728 48.2265 75.3189 46.0718M51.5414 30.1665C56.7455 31.9703 60.7179 36.2712 61.9097 41.5736C62.8989 41.3433 63.9323 41.2214 64.9947 41.2214C69.1848 41.2214 72.9165 43.1186 75.3189 46.0718",
    stroke: "#0C6CDE",
    strokeWidth: 2.67647,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.2118,
    height: 91,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGettingStartedGuildBlue);
export default __webpack_public_path__ + "static/media/Icon_GettingStarted_Guild_Blue.bfceceedf9a1c008156a1b5fb2c6d246.svg";
export { ForwardRef as ReactComponent };